import { throttleIfPossible } from "@faire/web--source/common/globals/throttleIfPossible";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import React, { useEffect, useMemo, useState } from "react";
import { createContext, useContext } from "react";

const SEARCH_USING_THROTTLE_THRESHOLD = 1;
const SEARCH_SUGGESTIONS_THROTTLE_TIME_MS = 50;

const Context = createContext<string>("");

export const useSearchSuggestionsThrottledQueryString = () => {
  return useContext(Context);
};

export const SearchSuggestionsThrottledQueryStringProvider = ({
  children,
  searchValue,
}: {
  children: React.ReactNode;
  searchValue: string;
}) => {
  const [throttledSearchValue, setThrottledSearchValue] = useState(searchValue);

  const updateThrottledSearchValue = useEffectEvent(() => {
    setThrottledSearchValue(searchValue);
  });

  const throttledUpdateThrottledSearchValue = useMemo(
    () =>
      throttleIfPossible(
        updateThrottledSearchValue,
        SEARCH_SUGGESTIONS_THROTTLE_TIME_MS
      ),
    [updateThrottledSearchValue]
  );

  useEffect(() => {
    throttledUpdateThrottledSearchValue();
  }, [searchValue, throttledUpdateThrottledSearchValue]);

  const value =
    searchValue.length >= SEARCH_USING_THROTTLE_THRESHOLD
      ? throttledSearchValue
      : searchValue;

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
